import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/brand";

export default function Footer({ onJoin, stats }) {
  const allClosed = stats?.all_closed;
  const foundersClosed = stats?.founders_closed;
  const label = allClosed ? "Founding 100 closed" : foundersClosed ? "Grab a Matcha Pass" : "Become a Founding Member";
  return (
    <footer className="bg-[#1A1A1A] text-[#F7F5F0] px-6 md:px-10 py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Hontō" className="w-8 h-8 object-contain" />
              <span className="font-serif text-2xl leading-none">Hontō <span className="italic font-light text-[#DDE3D5]">Matcha</span></span>
            </div>
            <p className="overline text-[#DDE3D5]/70 mt-6 mb-3">One last line</p>
            <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02]">
              Measured. Slow. <em className="text-[#C47253]">Honest</em>.
            </h2>
            <p className="mt-6 max-w-md text-[#DDE3D5] text-base leading-relaxed">
              Be one of the first hundred regulars at hōnto. No subscription, no commitment — just a first cup
              of Shizuoka-grade matcha, on us, near Mall of Dehradun.
            </p>
            <Button
              onClick={onJoin}
              disabled={allClosed}
              data-testid="footer-join-btn"
              className="mt-8 rounded-full bg-[#F7F5F0] text-[#1A1A1A] hover:bg-[#EBEFDE] disabled:opacity-50 disabled:cursor-not-allowed h-12 px-8 text-xs tracking-[0.22em] uppercase"
            >
              {label}
            </Button>
          </div>
          <div className="md:col-span-5 grid grid-cols-2 gap-8 text-sm">
            <div>
              <p className="overline text-[#DDE3D5]/70 mb-3">Find us</p>
              <p className="text-[#DDE3D5]">Near Mall of Dehradun</p>
              <p className="text-[#DDE3D5]">Uttarakhand, India</p>
              <p className="text-[#DDE3D5] mt-2">hello@hontomatcha.com</p>
            </div>
            <div>
              <p className="overline text-[#DDE3D5]/70 mb-3">Visit</p>
              <ul className="space-y-1 text-[#DDE3D5]">
                <li><a href="#philosophy" className="hover:text-[#F7F5F0]">Philosophy</a></li>
                <li><a href="#grades" className="hover:text-[#F7F5F0]">The Grades</a></li>
                <li><a href="#menu" className="hover:text-[#F7F5F0]">Menu</a></li>
                <li><a href="#pass" className="hover:text-[#F7F5F0]">Matcha Pass</a></li>
                <li><a href="#faq" className="hover:text-[#F7F5F0]">FAQ</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="ink-divider mt-16 opacity-30" />
        <div className="mt-8 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#DDE3D5]/70">
          <span>© 2026 hōnto matcha · Dehradun · A slow-bar, not a flagship.</span>
          <span className="font-serif italic">本当 — real, true, original.</span>
        </div>
      </div>
    </footer>
  );
}
